import React, { useEffect, useState } from 'react';
import { 
    GelBoxLayout, 
    GelButton,
    GelContainerLite, 
    GelForm, 
    GelFormField, 
    GelHeading3,
    GelParagraph,
    GelRowLayout, 
    GelTextArea, 
    GelTextInput,
    GelListItem,
    GelList
} from '@tal-gel/components';
import { 
    addressGroupPadding, 
    boldLabel, 
    requestPolicyForm, 
    subSectionMinHeight, 
    toastDiv, 
    toastFail, 
    toastSuccess
} from '../Shared/Styles';
import PostRequestEBQ from '../../services/PostRequestEBQ';
import ToastMessage from '../Shared/ToastMessage';
import { isEmpty } from 'lodash';
import { Link } from "react-router-dom";
import policySourceSystem from '../Shared/policySourceSystem';

const RequestEBQ = React.memo(({
    distributorClientNo,
    policyNumber,
    policyLives,
    policyDetails,
    policies,
    tlisQuoteFormURL
}) => {
    const [additionalDetails, setAdditionalDetails] = useState('');
    const [benefitPeriodValue, setBP] = useState('');
    const [cancelBenefitValue, setCB] = useState('');
    const [changeFrequencyValue, setCF] = useState('');
    const [declineCPIValue, setDCPI] = useState('');
    const [failToastMessage, setfailToastMessage] = useState(false);
    const [lifeInsuredName, setLifeInsuredName] = useState("");
    const [successToastMessage, setSuccessToastMessage] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [sidValue, setSID] = useState('');
    const [siiValue, setSII] = useState('');
    const [waitPeriodValue, setWP] = useState('');
    const [validForm, setValidForm] = useState(false);
    const [isTLIS, setIsTLIS] = useState("");
    const [TLISEmailBTLifeSubject, setTLISEmailBTLifeSubject] = useState("");
    const [TLISEmailtbcSubject, setTLISEmailtbcSubject] = useState("");

    const togglefailToastMessage = () => setfailToastMessage(!failToastMessage);
    const toggleSuccessToastMessage = () => setSuccessToastMessage(!successToastMessage);

    const queryString = window.location.search;

    const init = () => {

        var TLISEmailBTLifeSubject = "";
        var TLISEmailtbcSubject ="";

        if (policyLives && !isEmpty(policyLives)) {
            var policyLive = policyLives.find(e => e.distributorClientId.toString() === distributorClientNo);
        
            if (policyLive)
            setLifeInsuredName(policyLive.fullName);
        }
        
        if(policies && !isEmpty(policies)){
            var isTLIS = policySourceSystem(policies) === "PPlans"; 

            if(isTLIS)
            {                
                setIsTLIS(isTLIS);
                TLISEmailBTLifeSubject = "mailto:PPquotes@tal.com.au?subject=Replacement Quote Request - Policy No: " + policyNumber +" for Policy Owner/s: " + policyDetails?.policy?.policyOwner?.owner;
                TLISEmailtbcSubject = "mailto:tba@tal.com.au?subject=Replacement Quote Request - Policy No: " + policyNumber +" for Policy Owner/s: " + policyDetails?.policy?.policyOwner?.owner;
                setTLISEmailBTLifeSubject(TLISEmailBTLifeSubject);
                setTLISEmailtbcSubject(TLISEmailtbcSubject);
           }
        }        
    };

    const resetForm = (event) => {
        setAdditionalDetails('');
        setBP('');
        setCB('');
        setCF('');
        setDCPI('');
        setSII('');
        setSID('');
        setWP('');
    }

    const onFieldDataChange = (event) => {
        
        if (event.currentTarget.name === 'benefitPeriodChange') {
            setBP(event.target.value);
        }
        
        if (event.currentTarget.name === 'cancelBenefit') {
            setCB(event.target.value);
        }

        if (event.currentTarget.name === 'changeFrequency') {
            setCF(event.target.value);
        }

        if (event.currentTarget.name === 'declineCPI') {
            setDCPI(event.target.value);
        }

        if (event.currentTarget.name === 'sumInsuredIncreaseInput') {
            setSII(event.target.value);
        }

        if (event.currentTarget.name === 'sumInsuredDecreaseInput') {
            setSID(event.target.value);
        }

        if (event.currentTarget.name === 'waitingPeriodChange') {
            setWP(event.target.value);
        }
    }

    const setNotes = (event) => {
        setAdditionalDetails(event.target.value);
    }

    async function submit() {
        const payload = {
            additionalDetails: additionalDetails,
            sumInsuredIncrease: siiValue,
            sumInsuredDecrease: sidValue,
            waitingPeriod: waitPeriodValue,
            benefitPeriod: benefitPeriodValue,
            declineCPI: declineCPIValue,
            cancelBenefit: cancelBenefitValue,
            changeFrequency: changeFrequencyValue,
            lifeInsured: lifeInsuredName,
            owner: policyDetails.policy.policyOwner.owner,
            policyNumber: policyNumber,
            policyStatus: policyDetails.policy.status,
            isTLIS: isTLIS
        };

        const result = await PostRequestEBQ(payload);    

        if (result) {
            setSuccessToastMessage(true);
            setShowSuccessMessage(true);
            resetForm();
        }
        else {
            setfailToastMessage(true);
        }
    }

    useEffect(() => {
        try {
            init();
        }
        catch (error) {
            return (<div>error</div>);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [policyLives,policies]);

    useEffect(() => {
        try {
            setValidForm(benefitPeriodValue || cancelBenefitValue || changeFrequencyValue || declineCPIValue || siiValue || sidValue || waitPeriodValue);
        }
        catch (error) {
            return (<div>error</div>);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [benefitPeriodValue, cancelBenefitValue, changeFrequencyValue, declineCPIValue, siiValue, sidValue, waitPeriodValue]);

    return (
        <GelContainerLite style={subSectionMinHeight}>
            {showSuccessMessage 
                ?<GelRowLayout gutter="large">
                        <div>
                            Your request was successfully submitted.
                        </div>
    
                        <div>Please allow 3-5 business days to action email requests.</div>           
                        
                        <Link to={`/dashboard/policy-details${queryString}`}>
                            <div>Click here to go back to the Policy Details.</div>
                        </Link>
                 </GelRowLayout>
                :<GelRowLayout gutter="large">
                    {!isTLIS && <div data-testid="RequestEBQLabel">Please select the existing business quotes that you would like to request and your query will be forwarded to the appropriate business unit who will respond to you shortly.</div>}
                    {isTLIS && <div data-testid="RequestEBQTLISLabel">
                        <p>
                            <h4><strong>INFORCE QUOTES</strong></h4>
                            The below web form can be used to request an <b>Inforce quote</b>, and is used for general policy alterations only.
                        </p>

                        <p>
                            <h4><strong>REPLACEMENT QUOTES</strong></h4>
                            For a policy replacement or transfer (including a change of ownership or transferring on or off platform), you will need a <b>Replacement quote.</b> To obtain a replacement quote, please download a copy of the <a href={tlisQuoteFormURL} download >Protection Plans Manual Quote Form </a>, complete and return to us at <a href={TLISEmailBTLifeSubject}>PPquotes@tal.com.au</a>.
                        </p>

                        <p style={{color: "red"}}>
                            <b>Please note: This form must be downloaded to your device, edited and saved in Adobe Acrobat.</b>
                        </p>

                        <p>
                            For more information, please refer to the Protection Plans Adviser Guide or Quick Reference Guide - Protection Plans: Quotes.
                        </p>
                    </div>}
                    <GelForm
                        labelWidth={requestPolicyForm.formLabelWidth}
                        fieldGutter={requestPolicyForm.fieldGutter}
                        labelAtTop
                        disableOnSubmit
                        preventSubmitOnInvalid
                        onSubmit={submit}
                        onResponse={resetForm}
                    >
                        <GelRowLayout gutter="none">
                            <GelHeading3>
                                Quotes Available for Request
                            </GelHeading3>
                        </GelRowLayout>
                        {/* layout of this form is WIP. may need to be changed completely to closer match the mockups. */}
                        <GelRowLayout gutter="large">
                            <GelBoxLayout distribution="spaceBetween">
                                <GelRowLayout gutter="small">
                                    <div style={addressGroupPadding}>
                                        <GelFormField label="">
                                            <GelParagraph>Sum Insured / Benefit Amount Increase</GelParagraph>
                                            <GelTextInput
                                                name="sumInsuredIncreaseInput"
                                                data-testid="sumInsuredIncreaseInput"
                                                placeholder="Provide details of the benefits and from and to values"
                                                onChange={onFieldDataChange}
                                                value={siiValue}
                                                width="800px" />
                                        </GelFormField>
                                    </div>
                                    <div>
                                        <GelFormField label="">
                                            <GelParagraph>Sum Insured / Benefit Amount Decrease</GelParagraph>
                                            <GelTextInput
                                                name="sumInsuredDecreaseInput"
                                                data-testid="sumInsuredDecreaseInput"
                                                placeholder="Provide details of the benefits and from and to values"
                                                onChange={onFieldDataChange}
                                                value={sidValue}
                                                width="800px" />
                                        </GelFormField>
                                    </div>
                                    <div>
                                        <GelFormField label="">
                                            <GelParagraph>Waiting Period Change</GelParagraph>
                                            <GelTextInput
                                                name="waitingPeriodChange"
                                                data-testid="waitingPeriodChange"
                                                placeholder="Provide details of the benefits and from and to values"
                                                onChange={onFieldDataChange}
                                                value={waitPeriodValue}
                                                width="800px" />
                                        </GelFormField>
                                    </div>
                                    <div>
                                        <GelFormField label="">
                                            <GelParagraph>Benefit Period Change</GelParagraph>
                                            <GelTextInput
                                                name="benefitPeriodChange"
                                                data-testid="benefitPeriodChange"
                                                placeholder="Provide details of the benefits and from and to values"
                                                onChange={onFieldDataChange}
                                                value={benefitPeriodValue}
                                                width="800px" />
                                        </GelFormField>
                                    </div>
                                    <div>
                                        <GelFormField label="">
                                            <GelParagraph>Decline CPI</GelParagraph>
                                            <GelTextInput
                                                name="declineCPI"
                                                data-testid="declineCPI"
                                                placeholder="Provide details of the benefits"
                                                onChange={onFieldDataChange}
                                                value={declineCPIValue}
                                                width="800px" />
                                        </GelFormField>
                                    </div>
                                    <div>
                                        <GelFormField label="">
                                            <GelParagraph>Cancellation of Benefit</GelParagraph>
                                            <GelTextInput
                                                name="cancelBenefit"
                                                data-testid="cancelBenefit"
                                                placeholder="Provide details of the benefits"
                                                onChange={onFieldDataChange}
                                                value={cancelBenefitValue}
                                                width="800px" />
                                        </GelFormField>
                                    </div>
                                    <div>
                                        <GelFormField label="">
                                            <GelParagraph>Change Frequency</GelParagraph>
                                            <GelTextInput
                                                name="changeFrequency"
                                                data-testid="changeFrequency"
                                                placeholder="Provide details"
                                                onChange={onFieldDataChange}
                                                value={changeFrequencyValue}
                                                width="800px" />
                                        </GelFormField>
                                    </div>                                    
                                </GelRowLayout>
                            </GelBoxLayout>
                        </GelRowLayout>

                        {!isTLIS &&  <GelRowLayout style={{ paddingBottom: '40px' }}>
                            <GelHeading3 extralarge><span style={boldLabel}>NOTE: </span>For any other quotes, requests or alterations, please email <a href="mailto:communications@tal.com.au">communications@tal.com.au</a></GelHeading3>
                        </GelRowLayout> }

                        <GelRowLayout style={{ paddingBottom: '20px' }}>
                           {!isTLIS && <GelHeading3>
                                Add details to be sent with request
                            </GelHeading3>}
                            {isTLIS && <GelHeading3>
                                Add any other alteration details below:
                            </GelHeading3>}
                        </GelRowLayout>
                        <GelParagraph><span style={boldLabel}>NOTE: </span>Do not include any Banking, Credit Card or TFN details</GelParagraph>
                        <GelFormField
                            label=""
                        >   
                            <GelTextArea
                                name="additional-info-input"
                                data-testid="requestEBQAdditionDetails"
                                placeholder="NOTE: Do not include any Banking, Credit Card or TFN details."
                                rows={4}
                                value={additionalDetails}
                                onChange={setNotes}
                            />
                        </GelFormField>

                        {!isTLIS && <div><span style={boldLabel}>NOTE: </span>Please allow 3-5 business days to action email requests.</div>}

                        {isTLIS && <div>Please allow 2-3 business days to action email requests.</div>}                    
                        <GelBoxLayout
                            space="auto"
                            distribution="end"
                        >
                            <GelButton
                                data-testid="requestEBQReset"
                                secondary
                                medium
                                onClick={resetForm}
                            >
                                Reset
                            </GelButton>

                            <GelFormField>
                                <GelButton
                                    name=""
                                    data-testid="requestEBQSubmit"
                                    primary
                                    medium
                                    submit
                                    disabled={!validForm}
                                >
                                    Send
                                </GelButton>
                            </GelFormField>
                        </GelBoxLayout>
                    </GelForm>
                </GelRowLayout>    
            }

            <div style={toastDiv}>
                <ToastMessage
                    toggleToast={toggleSuccessToastMessage}
                    toastType={toastSuccess}
                    showToast={successToastMessage}
                    message={'Your request was successfully submitted. Please allow 3-5 business days to action email requests.'} />

                <ToastMessage
                    toggleToast={togglefailToastMessage}
                    toastType={toastFail}
                    showToast={failToastMessage}
                    message={'Your request was unsuccessful. Please try again.'} />
            </div>
        </GelContainerLite>
    )
});

export default RequestEBQ;